<app-cart [selectedCustomer]="selectedCustomer"
          [selectedProducts]="selectedProducts"        
          [disableDelete]="true"
          (cartUpdated)="onCartUpdated($event)"
          (editRequested)="editOrder()"
          (saveAsDraftRequested)="saveAsDraft()"
          (placeOrderRequested)="placeOrder()">
</app-cart>
